import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import moment from "moment";
import { Grid, Button, Checkbox, InputLabel } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

import TimePicker from "../../../partials/TimePicker";

import { styles } from "./styles";
import { isJsonString } from "../../../utils/setting";
class WorkingDaysComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timePicker: {
        day: "",
        name: "",
        open: false, // open dialog time-picker
      },
      workingDays: {
        monday: {
          from: moment().format("HH:mm"),
          to: moment().format("HH:mm"),
          off: 0,
        },
        tuesday: {
          from: moment().format("HH:mm"),
          to: moment().format("HH:mm"),
          off: 0,
        },
        wednesday: {
          from: moment().format("HH:mm"),
          to: moment().format("HH:mm"),
          off: 0,
        },
        thursday: {
          from: moment().format("HH:mm"),
          to: moment().format("HH:mm"),
          off: 0,
        },
        friday: {
          from: moment().format("HH:mm"),
          to: moment().format("HH:mm"),
          off: 0,
        },
        saturday: {
          from: moment().format("HH:mm"),
          to: moment().format("HH:mm"),
          off: 0,
        },
        sunday: {
          from: moment().format("HH:mm"),
          to: moment().format("HH:mm"),
          off: 1,
        },
      },
      time: new Date(),
    };
  }
  async componentDidMount() {
    const { service = {} } = this.props;
    this.props.onRef(this);
    if (Object.keys(service).length === 0) {
      await this.props.getServicesForRole();
    }
    if (service && service.workingDays) {
      let workingDays = service.workingDays;
      if (isJsonString(workingDays)) workingDays = JSON.parse(workingDays);
      this.setState({ workingDays: workingDays });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      this.props.service !== nextProps.service ||
      (this.props.service &&
        nextProps.service &&
        this.props.service.workingDays !== nextProps.service.workingDays)
    ) {
      let workingDays = nextProps.service.workingDays;

      if (typeof workingDays === "string") {
        try {
          workingDays = JSON.parse(workingDays);
        } catch (err) {
          console.log(err);
        }
      }
      this.setState({ workingDays: workingDays });
    }
  }
  handleDayOff(value, date, type) {
    let workingDays = this.state.workingDays;
    workingDays[date][type] = value ? 1 : 0;
    // if (type === "off") {
    //     workingDays[name][type] = (value) ? 1 : 0;
    // }
    // else{
    //     workingDays[name][type] = value;
    // }
    this.setState({ workingDays });
  }

  handleTimePicker = (date, type, value) => {
    let { workingDays = {} } = this.state;
    // workingDays[date][type] = value;
    workingDays[date][type] = moment(value).format("HH:mm");
    this.setState({ workingDays });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.handleUpdate("workingHours", this.state.workingDays);
  };

  render() {
    const { classes, t, disabled = false } = this.props;
    const { workingDays = {} } = this.state;
    return (
      <div>
        <Grid className={classes.rootTitle} container spacing={3}>
          <Grid item xs={12} sm={2}></Grid>

          <Grid item xs={12} sm={4}>
            <InputLabel className={classes.label}>
              {t("service_workingdays_opening_hour")}
            </InputLabel>
          </Grid>

          <Grid item xs={12} sm={4}>
            <InputLabel className={classes.label}>
              {t("service_workingdays_close_hour")}
            </InputLabel>
          </Grid>

          <Grid item xs={12} sm={2}>
            <InputLabel className={classes.label}>
              {t("service_workingdays_day_off")}
            </InputLabel>
          </Grid>
        </Grid>

        <Grid className={classes.root} container spacing={3}>
          <Grid item xs={12} sm={2}>
            <InputLabel className={classes.labelDay}>
              {t("service_workingdays_monday")}
            </InputLabel>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              fullWidth={true}
              invalidDateMessage=""
              value={moment(workingDays.monday.from, "HH:mm")}
              disabled={disabled || workingDays.monday.off === 1}
              handleChange={(value) =>
                this.handleTimePicker("monday", "from", value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              fullWidth={true}
              invalidDateMessage=""
              value={moment(workingDays.monday.to, "HH:mm")}
              disabled={disabled || workingDays.monday.off === 1}
              handleChange={(value) =>
                this.handleTimePicker("monday", "to", value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Checkbox
              className={classes.checkedBox}
              disabled={disabled}
              checked={workingDays.monday.off === 1 ? true : false}
              value={workingDays.monday.off.toString()}
              onChange={(e) =>
                this.handleDayOff(e.target.checked, "monday", "off")
              }
              color="primary"
            />
          </Grid>
        </Grid>

        <Grid className={classes.root} container spacing={3}>
          <Grid item xs={12} sm={2}>
            <InputLabel className={classes.labelDay}>
              {t("service_workingdays_tuesday")}
            </InputLabel>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              fullWidth={true}
              invalidDateMessage=""
              value={moment(workingDays.tuesday.from, "HH:mm")}
              disabled={disabled || workingDays.tuesday.off === 1}
              handleChange={(value) =>
                this.handleTimePicker("tuesday", "from", value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              fullWidth={true}
              invalidDateMessage=""
              value={moment(workingDays.tuesday.to, "HH:mm")}
              disabled={disabled || workingDays.tuesday.off === 1}
              handleChange={(value) =>
                this.handleTimePicker("tuesday", "to", value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Checkbox
              className={classes.checkedBox}
              disabled={disabled}
              checked={workingDays.tuesday.off === 1 ? true : false}
              value={workingDays.tuesday.off.toString()}
              onChange={(e) =>
                this.handleDayOff(e.target.checked, "tuesday", "off")
              }
              color="primary"
            />
          </Grid>
        </Grid>

        <Grid className={classes.root} container spacing={3}>
          <Grid item xs={12} sm={2}>
            <InputLabel className={classes.labelDay}>
              {t("service_workingdays_wednesday")}
            </InputLabel>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              fullWidth={true}
              invalidDateMessage=""
              value={moment(workingDays.wednesday.from, "HH:mm")}
              disabled={disabled || workingDays.wednesday.off === 1}
              handleChange={(value) =>
                this.handleTimePicker("wednesday", "from", value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              fullWidth={true}
              invalidDateMessage=""
              value={moment(workingDays.wednesday.to, "HH:mm")}
              disabled={disabled || workingDays.wednesday.off === 1}
              handleChange={(value) =>
                this.handleTimePicker("wednesday", "to", value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Checkbox
              className={classes.checkedBox}
              disabled={disabled}
              checked={workingDays.wednesday.off === 1}
              value={workingDays.wednesday.off.toString()}
              onChange={(e) =>
                this.handleDayOff(e.target.checked, "wednesday", "off")
              }
              color="primary"
            />
          </Grid>
        </Grid>

        <Grid className={classes.root} container spacing={3}>
          <Grid item xs={12} sm={2}>
            <InputLabel className={classes.labelDay}>
              {t("service_workingdays_thursday")}
            </InputLabel>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              fullWidth={true}
              invalidDateMessage=""
              value={moment(workingDays.thursday.from, "HH:mm")}
              disabled={disabled || workingDays.thursday.off === 1}
              handleChange={(value) =>
                this.handleTimePicker("thursday", "from", value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              fullWidth={true}
              invalidDateMessage=""
              value={moment(workingDays.thursday.to, "HH:mm")}
              disabled={disabled || workingDays.thursday.off === 1}
              handleChange={(value) =>
                this.handleTimePicker("thursday", "to", value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Checkbox
              className={classes.checkedBox}
              disabled={disabled}
              checked={workingDays.thursday.off === 1 ? true : false}
              value={workingDays.thursday.off.toString()}
              onChange={(e) =>
                this.handleDayOff(e.target.checked, "thursday", "off")
              }
              color="primary"
            />
          </Grid>
        </Grid>

        <Grid className={classes.root} container spacing={3}>
          <Grid item xs={12} sm={2}>
            <InputLabel className={classes.labelDay}>
              {t("service_workingdays_friday")}
            </InputLabel>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              fullWidth={true}
              invalidDateMessage=""
              value={moment(workingDays.friday.from, "HH:mm")}
              disabled={disabled || workingDays.friday.off === 1}
              handleChange={(value) =>
                this.handleTimePicker("friday", "from", value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              fullWidth={true}
              invalidDateMessage=""
              value={moment(workingDays.friday.to, "HH:mm")}
              disabled={disabled || workingDays.friday.off === 1}
              handleChange={(value) =>
                this.handleTimePicker("friday", "to", value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Checkbox
              className={classes.checkedBox}
              disabled={disabled}
              checked={workingDays.friday.off === 1 ? true : false}
              color="primary"
              value={workingDays.friday.off.toString()}
              onChange={(e) =>
                this.handleDayOff(e.target.checked, "friday", "off")
              }
            />
          </Grid>
        </Grid>

        <Grid className={classes.root} container spacing={3}>
          <Grid item xs={12} sm={2}>
            <InputLabel className={classes.labelDay}>
              {t("service_workingdays_saturday")}
            </InputLabel>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              fullWidth={true}
              invalidDateMessage=""
              value={moment(workingDays.saturday.from, "HH:mm")}
              disabled={disabled || workingDays.saturday.off === 1}
              handleChange={(value) =>
                this.handleTimePicker("saturday", "from", value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              fullWidth={true}
              invalidDateMessage=""
              value={moment(workingDays.saturday.to, "HH:mm")}
              disabled={disabled || workingDays.saturday.off === 1}
              handleChange={(value) =>
                this.handleTimePicker("saturday", "to", value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Checkbox
              className={classes.checkedBox}
              disabled={disabled}
              checked={workingDays.saturday.off === 1 ? true : false}
              value={workingDays.saturday.off.toString()}
              color="primary"
              onChange={(e) =>
                this.handleDayOff(e.target.checked, "saturday", "off")
              }
            />
          </Grid>
        </Grid>

        <Grid className={classes.root} container spacing={3}>
          <Grid item xs={12} sm={2}>
            <InputLabel className={classes.labelDay}>
              {t("service_workingdays_sunday")}
            </InputLabel>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              fullWidth={true}
              invalidDateMessage=""
              value={moment(workingDays.sunday.from, "HH:mm")}
              disabled={disabled || workingDays.sunday.off === 1}
              handleChange={(value) =>
                this.handleTimePicker("sunday", "from", value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              fullWidth={true}
              invalidDateMessage=""
              value={moment(workingDays.sunday.to, "HH:mm")}
              disabled={disabled || workingDays.sunday.off === 1}
              handleChange={(value) =>
                this.handleTimePicker("sunday", "to", value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Checkbox
              className={classes.checkedBox}
              disabled={disabled}
              checked={workingDays.sunday.off === 1 ? true : false}
              value={workingDays.sunday.off.toString()}
              color="primary"
              onChange={(e) =>
                this.handleDayOff(e.target.checked, "sunday", "off")
              }
            />
          </Grid>
        </Grid>

        <Grid container justify="flex-end">
          <Button
            disabled={disabled}
            onClick={this.handleSubmit}
            color="primary"
            size="large"
            variant="contained"
            component="span"
            className={classes.button}
          >
            {" "}
            {t("service_ownerspa_servicedetail_update")}{" "}
          </Button>
        </Grid>
      </div>
    );
  }
}

WorkingDaysComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  userState: state.user,
  service: state.service.service,
  role: state.user.user.roleId.role,
  ownerCode: state.service.service.userCode,
});

const mapDispatch = (dispatch) => ({
  userDispatch: dispatch.user,
  getServicesForRole: dispatch.service.getServicesForRole,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(WorkingDaysComponent)
  )
);
